module.exports = __webpack_public_path__ + "img/keylock.08d002eb.png";